import React from 'react'
import cx from 'classnames'

import { Icon } from 'components/_new/ui'
import { Href } from 'components/_new/controls'

import s from './BackLink.scss'


type BackLinkProps = {
  to?: string
  color?: 'black' | 'white' | 'whiteCold'
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
}

const BackLink: React.FunctionComponent<BackLinkProps> = (props) => {
  const { to, color = 'black', onClick } = props

  const containerClassName = cx(s.container, s[color])

  return (
    <Href
      className={containerClassName}
      to={to}
      role={!to ? 'button' : undefined}
      onClick={onClick}
    >
      <Icon name="leftArrow" size={12} noWrapper />
    </Href>
  )
}


export default BackLink
